// @internal
import './number-operations';

Node.prototype.replaceNewlines = function (): void
{
	let textContent, pos, preContent, postContent;

	for (let i = 0; i < this.childNodes.length; i++)
	{
		if (this.childNodes[i] instanceof Text)
		{
			textContent = this.childNodes[i].textContent;
			pos = textContent === null ? -1 : textContent.indexOf('\n');

			if (pos > -1 && textContent !== null)
			{
				preContent = textContent.substring(0, pos);
				postContent = textContent.substring(pos + 1);

				this.childNodes[i].textContent = postContent;

				if (preContent != '')
				{
					this.insertBefore(document.createTextNode(preContent), this.childNodes[i]);
				}

				this.insertBefore(document.createElement('br'), this.childNodes[i + (preContent == '' ? 0 : 1)]);
			}
		}
		else if (this.childNodes[i] instanceof Node)
		{
			this.childNodes[i].replaceNewlines();
		}
	}
};

(Node as any).prototype.querySelectorParent = function(selectors: string): Element | null
{
	if (this instanceof Element)
	{
		return (this as Element).querySelectorParent(selectors);
	}
	else
	{
		return null;
	}
}
